export default __webpack_public_path__ + "static/media/cara-triste.2d2817f3.png";